module.exports = __webpack_public_path__ + "static/media/Whisper Repeating.6b922fcb.jpg";